import * as React from 'react';
import { ChatContent } from './ChatContent';
import { useChatStore } from './chatStore';

interface ChatDrawerProps {
  factoryUrl?: string;
  adminToken?: string;
  className?: string;
  /** When provided, renders instead of the built-in ChatContent. */
  children?: React.ReactNode;
}

export function ChatDrawer({ factoryUrl, adminToken, className, children }: ChatDrawerProps) {
  const panelOpen = useChatStore((s) => s.panelOpen);
  const setPanelOpen = useChatStore((s) => s.setPanelOpen);

  const touchStartX = React.useRef(0);
  const [dragOffset, setDragOffset] = React.useState(0);
  const isDragging = dragOffset > 0;

  function handleTouchStart(e: React.TouchEvent) {
    touchStartX.current = e.touches[0].clientX;
  }

  function handleTouchMove(e: React.TouchEvent) {
    const delta = e.touches[0].clientX - touchStartX.current;
    if (delta > 0) setDragOffset(delta);
  }

  function handleTouchEnd() {
    if (dragOffset > 80) setPanelOpen(false);
    setDragOffset(0);
  }

  return (
    <aside
      aria-label="Chat panel"
      aria-hidden={!panelOpen}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      className={[
        'fixed inset-y-0 right-0 z-40 flex w-full flex-col bg-background border-l border-border shadow-2xl sm:w-[400px]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        transform: !panelOpen
          ? 'translateX(100%)'
          : dragOffset > 0
            ? `translateX(${dragOffset}px)`
            : 'translateX(0)',
        transition: isDragging ? 'none' : 'transform 300ms ease-in-out',
      }}
    >
      {panelOpen && (children ?? <ChatContent factoryUrl={factoryUrl} adminToken={adminToken} />)}
    </aside>
  );
}
